<script>
import ElMenuItem from 'vue-xpc/src/element-ui/packages/menu/src/menu-item.vue';
import ElSubmenu from 'vue-xpc/src/element-ui/packages/menu/src/submenu.vue';
import config from '../../../config';
export default {
  name: 'RtSidebarMenuBody',
  components: { ElMenuItem, ElSubmenu },
  props: {
    dataSource: {
      type: Array
    },
    theme: {
      type: String
    },
    collapse: {
      type: Boolean,
      default: false
    },
    defaultActive: {
      type: String
    },
    defaultOpeneds: {
      type: Array
    },
    alias: {
      type: Object,
      default () {
        return {};
      }
    }
  },
  data () {
    return {
      innerCollapse: this.collapse
    };
  },
  computed: {
    innerAlias () {
      return {
        title: 'title',
        desc: 'desc',
        path: 'path',
        id: 'id',
        iconName: 'iconName',
        iconSrc: 'iconSrc',
        children: 'children',
        ...this.alias
      };
    }
  },
  watch: {
    collapse (val) {
      if (val) {
        setTimeout(() => {
          this.innerCollapse = val;
        }, 350);
      } else {
        this.innerCollapse = val;
      }
    }
  },

  methods: {},
  render (h) {
    const getMenVNodeList = (dataSource, parentKey = 0) => {
      if (dataSource && dataSource.length > 0) {
        return dataSource.map((data, index) => {
          const key = `${parentKey}-${index}-${data[this.innerAlias.path]}`;
          const hasChildren =
            data[this.innerAlias.children] &&
            data[this.innerAlias.children].length > 0;

          const titleContentTag = hasChildren ? 'div' : 'el-menu-item';
          const titleContentParams = hasChildren
            ? {}
            : { props: { index: data[this.innerAlias.id], dataSource: data } };

          const iconName = data[this.innerAlias.iconSrc] ? '' : data[this.innerAlias.iconName] ? data[this.innerAlias.iconName] : config.get().defaultIconName;

          const icon = data[this.innerAlias.iconName] || data[this.innerAlias.iconSrc]
            ? h('rt-icon', {
              attrs: {
                size: this.collapse ? 24 : 16,
                name: iconName,
                imgSrc: data[this.innerAlias.iconSrc]
              }
            })
            : null;

          const titleContent = h(titleContentTag, titleContentParams, [
            icon,
            h('span', data[this.innerAlias.title])
          ]);
          const title = h(
            'rt-tooltip',
            {
              attrs: {
                content: data[this.innerAlias.title],
                disabled: data[this.innerAlias.title].length <= 8,
                effect: 'dark',
                placement: 'right'
              },
              slot: hasChildren ? 'title' : undefined
            },
            [titleContent]
          );

          if (hasChildren) {
            const childrenVNode = getMenVNodeList(
              data[this.innerAlias.children],
              key
            );
            return h(
              'rt-submenu',
              {
                attrs: {
                  key: key,
                  index: data[this.innerAlias.id]
                },
                props: {
                  collapse: this.innerCollapse,
                  dataSource: data,
                  popperClass: `rt-sidebar-menu-popup rt-sidebar-menu-${this.theme}`
                }
              },
              [title, childrenVNode]
            );
          }

          return title;
        });
      }
    };
    const list = getMenVNodeList(this.dataSource, 0);
    return h(
      'rt-menu',
      {
        class: this.collapse ? 'el-menu--collapse' : '',
        props: {
          uniqueOpened: true,
          collapse: this.innerCollapse,
          menuHeight: 'medium',
          collapseTransition: false,
          defaultActive: this.defaultActive,
          defaultOpeneds: this.defaultOpeneds
        },
        on: {
          select: (index, indexPath, item) => {
            this.$emit('select', index, item.$props.dataSource);
          },
          open: (index, indexPath, item) => {
            this.$emit('open', index, item.$props.dataSource);
          },
          close: (index, indexPath, item) => {
            this.$emit('close', index, item.$props.dataSource);
          }
        }
      },
      list
    );
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// rtSidebarMenuBody.vue?c0460bee